// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3UN_9","left":"styles_left__3oLvW","desktopActions":"styles_desktopActions__169zV","title":"styles_title__1Ldts"};